<template>
	<div class="process" v-loading="loading" element-loading-text="数据加载中...">
		<div class="search">
			<span>组别管理</span>
			<!-- <el-input placeholder="请输入关键字" v-model="searchForm.keyword"></el-input>
		<el-button type="success" @click="getList">搜 索</el-button> -->
			<el-button type="success" @click="openTree">添 加</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" height="700px" align="center" :header-cell-style="{ background: '#f4f7fe' }">
				<el-table-column prop="teamGroupName" label="组别姓名" width="150"></el-table-column>
				<el-table-column prop="userNames" label="成员"></el-table-column>
				<el-table-column label="操作" width="200" align="right">
					<template slot-scope="scope">
						<el-button @click="openEdit(scope.row)" type="success" size="small">编辑</el-button>
						<el-button @click="deleteRowData(scope.row)" type="success" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-sizes="[10, 20, 50]"
				layout="sizes, prev, pager, next"
				:total="total"
			></el-pagination>
		</div>
		<!-- 右侧组别 -->
		<el-drawer size="20%" :modal="false" :title="currentType=='add'?'新增组别':'编辑组别'" :visible.sync="showTree"  @close="closeTree">
			<span style="margin-right:10px">组别名称</span>
			<el-input placeholder="请输入组别名称" v-model="teamName" style="width: 188px"></el-input>
			<el-scrollbar style="height:80%;margin-top: 8px;border: 1px solid #DCDFE6;border-radius: 4px;">
				<el-tree style="margin-top:20px" ref="tree" node-key="value" :data="operaterList" show-checkbox></el-tree>
			</el-scrollbar>
			<el-button type="success" style="width: 100%;margin-top: 10px;" @click="save(1)" v-if="currentType=='add'"  :loading="loading">添 加</el-button>
			<el-button type="success" style="width: 100%;margin-top: 10px;" @click="save(2)" v-if="currentType=='edit'" :loading="loading">保 存</el-button>
		</el-drawer>
	</div>
</template>

<script>
import { GetMapuserTreeList,GetMyMapToken } from '@/api/staff.js';
import { GetMapTeamGroup, AddMapShare, DeleteMapShare, UpdateMapShare } from '@/api/Map.js';
import { saveGroupAndPat,deleteTeamGroup }from '@/assets/api/team.js';
export default {
	name: 'ShareGroup',
	components: {},
	data() {
		return {
			date: '',
			loading: false, // 数据是否处于加载状态
			tableData: [], // 表格数据
			total: 0, // 数据总数
			currentPage: 1, // 当前页数
			pageSize: 10, // 当前查询数据个数
			showTree: false, //是否展示部门树
			operaterList: [], //部门树
			teamName:'',
			currentType:'add',
			teamGroupId:null,
			teamId:1,
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	async mounted() {
		this.$nextTick(()=>{
			let token = JSON.parse(localStorage.getItem('user-token-gispai'))
			GetMyMapToken(token).then(res=>{
				if(res.data.state>0){
					if(res.data.state==2){
						localStorage.setItem('user-token-gispai', JSON.stringify(res.data.data));
						let user_gispai = JSON.parse(JSON.parse(localStorage.getItem("user_gispai")))
          				user_gispai.Token = res.data.data
          				localStorage.setItem('user_gispai',JSON.stringify(JSON.stringify(user_gispai)))
					}
				}else{
					this.$message.error(res.data.msg)
				}
			})
			this.getList();
			this.getTreeData()
		})
		
	},
	methods: {
		// 修改权限
		edit() {
			UpdateMapShare(this.editFrom).then(res => {
				if (res.data.state == 1) {
					this.DialogShow = false;
					this.$message.success('修改成功');
					this.getList();
				}
			});
		},
		// 添加组别
		save(type) {
			let Pats = []
			this.$refs.tree.getCheckedNodes().forEach(element => {
				if(element.type==2){
					Pats.push(element.value);
				}
			});
			if(Pats.length==0){
				return this.$message.warning('请选择组成员');
			}
			if(this.teamName == ''){
				return this.$message.warning('请填写组名');
			}
			this.loading = true
			let params={
				TeamId:1,
				TeamGroupName:this.teamName,
				Pats,
			}
			if(type==2){
				params.TeamGroupId = this.teamGroupId
			}
			saveGroupAndPat(params).then(res => {
				if (res.data.Status == 0) {
					this.$message.success('操作成功');
					this.loading = false
					this.closeTree();
					this.getList();
				}else{
					this.$message.error(res.data.msg);
					this.loading = false
				}
			});
		},
		getTreeData(){
			GetMapuserTreeList().then(res => {
				this.operaterList = res.data.data;
			});
		},
		// 打开添加树
		openTree() {
			this.showTree = true;
			this.currentType = 'add'
		},
		// 关闭添加树
		closeTree() {
			this.$refs.tree.setCheckedKeys([])
			this.teamName = ''
			this.showTree = false;
		},
		// 分页查询
		handleSizeChange(e) {
			this.pageSize = e;
			this.getList();
		},
		handleCurrentChange(e) {
			this.currentPage = e;
			this.getList();
		},
		/*获取所有数据列表 */
		async getList() {
			this.loading = true
			try {
				let params = {
					pageNumber: this.currentPage,
					pageSize: this.pageSize
				};
				let { data } = await GetMapTeamGroup(params);
				if (data.state === 1) {
					data = data.data;
					this.tableData = data.lis;
					this.total = data.lis.length
				} else {
					this.$message.error(data.msg);
				}
				this.loading = false
			} catch (err) {
				this.loading = false
				this.$message.error("获取列表失败,请稍后重试!");
			}
		},
		// 编辑
		openEdit(row) {
			let arr = []
			this.currentType = 'edit'
			this.teamGroupId = row.teamGroupId;
			this.teamId = row.teamId;
			this.teamName = row.teamGroupName;
			// row.userIdLis.forEach(item=>arr.push(parseInt(item)))
			this.showTree = true;
			setTimeout(()=>{
				this.$refs.tree.setCheckedKeys(row.userIdLis)
			},300)
		},
		/* 通过ID删除单行数据 */
		deleteRowData(row) {
			this.$confirm("此操作将删除该分组，删除后整个团队将不存在该组别，是否继续？", "提示", {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let userId = JSON.parse(JSON.parse(localStorage.getItem('user_gispai'))).userid
					var param = {
					  teamGroupId: row.teamGroupId,
					  userId
					};
					deleteTeamGroup(param).then(res => {
						if (res.data.Status == 0) {
							this.$message.success('操作成功');
							this.getList();
						} else {
							this.$message.erroe(res.data.Msg);
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>
<style lang="less" scoped>
.process {
	height: 100%;
	position: relative;
	.closeIcon {
		color: #f56c6c;
		float: right;
		margin-top: -20px;
		margin-right: 10px;
		font-size: 22px;
		cursor: pointer;
	}
	.closeIcon:hover {
		color: red;
	}
	.search {
		padding: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		span {
			font-size: 20px;
			font-weight: bold;
		}
		.condition {
			display: flex;
			align-items: center;
			margin-right: 20px;
		}
	}
	.table {
		padding: 0px 15px;
	}
	.page {
		text-align: center;
	}
	/deep/ .el-dialog__header {
		padding: 10px;
		background-color: #5bacf0;
	}
	/deep/ .el-dialog__title {
		color: #fff;
	}
	/deep/ .el-dialog__body {
		padding: 15px;
	}
	/deep/ .el-dialog__footer {
		padding: 0px 10px 10px 10px;
	}
	/deep/ .el-drawer {
		top: 60px !important;
		height: 100% !important;
	}
	.tree {
		// background-color: #fff;
		// height: 500px;
		// width: 300px;
		// position: absolute;
		// right: 0;
		position: absolute;
		right: 0px;
		top: 0px;
		height: calc(100% - 60px);
		width: 300px;
		border: 1px solid #ccc;
		background-color: #fff;
		transition: all 0.3s ease;
		padding-top: 40px;
		padding: 40px 20px 20px 20px;
		z-index: 20;
		// width: 0px;
		.close_icon {
			position: absolute;
			top: 10px;
			right: 10px;
			cursor: pointer;
			color: #f56c6c;
			font-size: 22px;
		}
		.close_icon:hover {
			color: red;
		}
	}
}
</style>
